import { render, staticRenderFns } from "./Step5Car.vue?vue&type=template&id=13632188"
import script from "./Step5Car.vue?vue&type=script&lang=js"
export * from "./Step5Car.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports